export default {
  unitPlans: state => type => {
    return state[type].plans
  },
  unitPlanFilters: state => type => {
    return state[type].PlanFilters
  },
  unitPlansCounter: state => type => {
    return state[type].PlansCounter
  },
}
